import styled from 'styled-components';
import MuiTabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';

export const Tabs = withStyles({
  root: {
    flexGrow: 1,
  },

  indicator: {
    backgroundColor: ' var(--brand-color)',
  },
})(MuiTabs);

export const SelectionTabs = styled.div`
  display: flex;
  justify-content: stretch;
  align-self: stretch;

  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 0 0.5em;
`;

export const LPSubText = styled.p`
  color: var(--text-secondary-color);
  font-size: 0.9em;
  line-height: 1.6;
`;

export const BookingsListWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;
